import { useLayoutEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { currentAppHref, redirectToStaffLogin, shouldUsePortalAuth } from '../utils/portalAuth';

function isStaffLoggingOut() {
  try {
    return sessionStorage.getItem('maap:staff_logging_out') === '1';
  } catch {
    return false;
  }
}

const StaffLoginRedirect = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Logout already hard-redirects to Portal with ?signed_out=1.
    // Do not bounce with ?next= — that lands on the app selector.
    if (isStaffLoggingOut()) return;
    if (shouldUsePortalAuth()) {
      redirectToStaffLogin({ next: currentAppHref() });
    }
  }, []);

  if (shouldUsePortalAuth()) {
    return null;
  }

  return <Navigate to="/login" replace state={{ from: location }} />;
};

export default StaffLoginRedirect;
